import { boundsTooBig } from "./bbox"

export function checkedLayerKeys(controls = []) {
  return Array.from(controls || [])
    .filter(control => control.checked)
    .map(control => control.dataset?.layer)
    .filter(Boolean)
}

export function mapLayerSearchPlan({ searching = false, controls = [], params = "", bounds = null, layerLimits = {} } = {}) {
  if (searching) return { kind: "queue" }

  const activeKeys = checkedLayerKeys(controls)
  if (!activeKeys.length) return { kind: "status", status: "Enable a layer to search." }

  const zoomLimitedKeys = activeKeys.filter(key => layerTooBig(bounds, layerLimits[key]))
  const fetchKeys = activeKeys.filter(key => !zoomLimitedKeys.includes(key))
  if (!fetchKeys.length) return { kind: "status", status: zoomInStatus(zoomLimitedKeys) }

  return {
    kind: "search",
    activeKeys: fetchKeys,
    zoomLimitedKeys,
    params,
    status: "Searching…"
  }
}

export function layerErrorMessage(key, reason) {
  const message = reason?.message || String(reason || "error")
  return `${key}: ${message}`
}

export function layerSearchStatus(activeKeys = [], results = [], zoomLimitedKeys = []) {
  const messages = results.map((result, index) =>
    result.status === "fulfilled" ? result.value : layerErrorMessage(activeKeys[index], result.reason)
  )
  if (zoomLimitedKeys.length) messages.push(zoomInStatus(zoomLimitedKeys))
  return messages.join(" · ")
}

function layerTooBig(bounds, limit) {
  const maxDegrees = Number(limit)
  return !!bounds && Number.isFinite(maxDegrees) && maxDegrees > 0 && boundsTooBig(bounds, maxDegrees)
}

function zoomInStatus(keys) {
  return `Zoom in for ${keys.join(", ")}`
}
